import { SidebarMenuItemContainer, SidebarMenuItemBadge } from './styled.js';
import { IconContainer, FadeOutContainer, FadeOutSpacer } from '../components/index.js';
import { useSidebarMenu } from '../useSidebarMenu/index.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Tooltip } from '../../../dataDisplay/Tooltip/Tooltip/index.js';
import { Typography } from '../../../foundation/Typography/styled.js';

function SidebarMenuItem(props) {
  var icon = props.icon,
    label = props.label,
    _props$active = props.active,
    active = _props$active === void 0 ? false : _props$active,
    _props$showBadgeOnMin = props.showBadgeOnMinimize,
    showBadgeOnMinimize = _props$showBadgeOnMin === void 0 ? false : _props$showBadgeOnMin,
    adornmentRight = props.adornmentRight,
    className = props.className,
    onClick = props.onClick;
  var _useSidebarMenu = useSidebarMenu(),
    minimized = _useSidebarMenu.minimized;
  var showBadge = showBadgeOnMinimize && minimized;
  return /*#__PURE__*/jsxs(SidebarMenuItemContainer, {
    $active: active,
    onClick: onClick,
    className: className,
    children: [/*#__PURE__*/jsx(Tooltip, {
      disabled: !minimized,
      title: label,
      position: "right",
      children: /*#__PURE__*/jsxs(IconContainer, {
        children: [icon, /*#__PURE__*/jsx(SidebarMenuItemBadge, {
          $show: showBadge
        })]
      })
    }), /*#__PURE__*/jsx(FadeOutContainer, {
      $minimized: minimized,
      children: /*#__PURE__*/jsxs(FadeOutSpacer, {
        children: [/*#__PURE__*/jsx(Typography, {
          $fontWeight: "regular",
          $fontSize: "medium",
          children: label
        }), /*#__PURE__*/jsx(IconContainer, {
          children: adornmentRight
        })]
      })
    })]
  });
}

export { SidebarMenuItem };
